<template>
  <RichTextEditor
    ref="innerEditor"
    v-model="localName"
    class="w-full"
    :disabled="disabled"
    @blur="handleBlur"
  />
</template>

<script setup lang="ts">
// Per-row buffer around RichTextEditor for answer-option labels. Without this,
// every keystroke writes directly into option.name on the live config tree,
// which restarts the autosave debounce and opens a window for an inbound
// Pusher DraftConfigUpdated event (cross-tab self-echo, or the ENG-1051
// snapshots write source) to refetch and three-way merge over the in-flight
// edit, reverting the field. Mirrors useDebouncedField pattern from
// SegmentGroupOverview.vue. (ENG-1052; prior fixes ENG-1014, ENG-1024.)
import { Segment } from '@/types/config'
import RichTextEditor from '@/components/common/RichTextEditor.vue'

const props = defineProps<{
  option: Segment
  disabled?: boolean
}>()

const innerEditor = useTemplateRef<{ editor: any }>('innerEditor')

const localName = useDebouncedField(
  () => props.option?.name ?? '',
  (v) => {
    if (props.option) props.option.name = v
  },
)

const editor = computed(() => innerEditor.value?.editor)

function handleBlur() {
  localName.flushNow()
}

defineExpose({ editor })
</script>
